// Browser stub for Node builtins (fs/path) pulled into client bundles via
// barrel re-exports. Must satisfy named ESM imports such as
// `import { promises as fs } from 'fs'` and `import { resolve } from 'path'`.
const promises = {
    readFile: async () => '',
    writeFile: async () => {},
    access: async () => {},
    stat: async () => ({ isFile: () => false, isDirectory: () => false }),
    readdir: async () => [],
    mkdir: async () => {},
}

function resolve(...parts) {
    return parts.filter((p) => p != null && p !== '').join('/').replace(/\/+/g, '/')
}

module.exports = {
    promises,
    readFileSync: () => '',
    writeFileSync: () => {},
    existsSync: () => false,
    accessSync: () => {},
    resolve,
    join: resolve,
    dirname: (p) => String(p).replace(/\/[^/]*$/, '') || '.',
    basename: (p) => String(p).split('/').pop() || '',
    extname: (p) => {
        const base = String(p).split('/').pop() || ''
        const i = base.lastIndexOf('.')
        return i > 0 ? base.slice(i) : ''
    },
    sep: '/',
    posix: { resolve, join: resolve },
}
